import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { logout } from "../api_client/allauth";
import Button from "@sharpana/ui/Button";
import { css } from "@emotion/react";

const containerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #141414;
  color: #ffffff;
  text-align: center;
`;

const cardStyles = css`
  max-width: 400px;
  padding: 2rem;
  border-radius: 8px;
  background-color: #1e1e1e;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const buttonStyles = css`
  margin-top: 1.5rem;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: 600;
  background-color: rgb(157, 60, 231);
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: rgb(137, 52, 202);
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(157, 60, 231, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const buttonRowStyles = css`
  margin-top: 1.5rem;
  display: flex;
  gap: 14px;
  justify-content: center;
`;

const logoutButtonStyles = css`
  ${buttonStyles};
  margin-top: 0;
  background-color: rgb(120 73 40);
  &:hover {
    background-color: rgb(120 73 40);
  }
`;

const cancelButtonStyles = css`
  ${buttonStyles};
  margin-top: 0;
`;

export default function Logout() {
  const navigate = useNavigate();
  const [response, setResponse] = useState({ fetching: false, content: null });

  function submit() {
    setResponse({ ...response, fetching: true });
    logout()
      .then((content) => {
        setResponse((r) => {
          return { ...r, content };
        });
      })
      .catch((e) => {
        console.error(e);
        window.alert(e);
      })
      .then(() => {
        setResponse((r) => {
          return { ...r, fetching: false };
        });
      });
  }
  if (response.content) {
    return <Navigate to="/" />;
  }
  return (
    <div css={containerStyles}>
      <div css={cardStyles}>
        <h1>Logout</h1>
        <p>Are you sure you want to logout?</p>

        <div css={buttonRowStyles}>
          <button
            css={logoutButtonStyles}
            disabled={response.fetching}
            onClick={() => submit()}
          >
            Logout
          </button>
          <button css={cancelButtonStyles} onClick={() => navigate("/settings")}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
